module.exports = __webpack_public_path__ + "img/Logo_Bank_Indonesia.2b22d1e3.png";